import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {theme} from './Assets/css/mui';
import { ThemeProvider } from '@mui/material/styles';
import {SnackbarProvider} from 'notistack';
import {Provider} from  'react-redux';
import ReduxThunk from 'redux-thunk';
import {legacy_createStore as createStore, applyMiddleware} from 'redux';
import rootReducer from './Store';
import { applyCachedTheme } from './Utility/theme';

export const store = createStore(rootReducer, applyMiddleware(ReduxThunk));
applyCachedTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
      <SnackbarProvider autoHideDuration={3000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Provider store = {store}>
          <App />
        </Provider>
      </SnackbarProvider>
  </ThemeProvider>
);


reportWebVitals();

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register(`${process.env.PUBLIC_URL}/service-worker.js`)
//       .then((registration) => {
//         console.log("Service Worker registered:", registration);
//       })
//       .catch((error) => {
//         console.log("Service Worker registration failed:", error);
//       });
//   });
// }
